import { variables } from "./components/variables";
import Choices from "choices.js";

(function($) {


    /**
     * Add Choices.js to select dropdowns
     */
    const $selects = $('select');
    $selects.each(function(){
      
        // Handle tab selects only on mobile
        if ( $(this).hasClass('bde-tabs__select') && screen_width > variables.largeTabletBreakpoint ) {
            return;
        }

        const choices = new Choices($(this)[0], {
            allowHTML: true,
            searchEnabled: false,
            shouldSort: false,
            itemSelectText: ""
        });
    });

	
})( jQuery );

/**
 * Accessibe
 */
(function(){ var s = document.createElement('script'); var h = document.querySelector('head') || document.body; s.src = 'https://acsbapp.com/apps/app/dist/js/app.js'; s.async = true; s.onload = function(){ acsbJS.init(); }; h.appendChild(s); })();

